import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-stock-transfer-select',
  templateUrl: './stock-transfer-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StockTransferSelectComponent),
      multi: true
    }
  ]
})
export class StockTransferSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `contains(docCode, '${encodeURIComponent(searchStr)}')`;
    }
    let url = `api/stocktransfers/lookup?$top=20&$skip=0&$orderby=docCode desc`;
    if (filter) url += `&$filter=${filter}`;
    return url;
  }
}